import React from "react";

const SlideGrid = ({ slides, onEdit, onCreate, onDelete, onClearAll }) => {
  return (
    <section className="content container-fluid mt-4">
      <div className="row">
        <div className="col-lg-8 col-md-10 col-sm-12 col-xs-12 col-lg-offset-2 col-md-offset-1">
          <div className="box box-primary">
            <div className="box-header with-border d-flex justify-content-between align-items-center">
              <h3>Slides Grid</h3>
              <div>
                <button className="btn btn-primary me-2" onClick={onCreate}>
                  Create New
                </button>
                <button className="btn btn-danger" onClick={onClearAll}>
                  Clear All
                </button>
              </div>
            </div>
            <div className="box-body">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>label</th>
                    <th>Slides</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {slides.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No entries found.
                      </td>
                    </tr>
                  ) : (
                    slides.map((slide, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{slide.label}</td>
                        <td>
                          {slide.image && (
                            <img
                              src={slide.image}
                              alt="Preview"
                              style={{ width: "100px", borderRadius: 6 }}
                            />
                          )}
                        </td>
                        <td>
                          <button
                            className="btn btn-primary btn-sm me-2"
                            onClick={() => onEdit(slide)}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => onDelete(slide.id)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SlideGrid;
